import { ReactComponent as Icon } from '../../assets/icons/resetPassword.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" />;
}
